const LOCAL_STORAGE_KEYS = {
  CLS_EVENT: 'clsEvent',
};

export default LOCAL_STORAGE_KEYS;



// WEBPACK FOOTER //
// ../shared/js/constants/localStorage.constants.js